import { Col, Divider, message, Radio, Row } from "antd";
import { InputBox } from "../../../../../../components/AntdAddons";
import { Fragment, useEffect, useState } from "react";
import { includes } from "lodash";
import { IMAGE_UPLOAD } from "../../../../../../config/Constant";

const BannerSection: React.FC<any> = ({ sectionDetails, form }) => {



  useEffect(() => {
    if (sectionDetails?.banner_logo) {
      form.setFieldsValue({ banner_logo: sectionDetails?.banner_logo })
    }


  }, [sectionDetails?.banner_logo]);

  return (
    <>
      <Row gutter={15}>
        <Col xs={{ span: 24 }} md={{ span: 24 }}>




          <InputBox.ImageUpload
            required
            imageUrl={sectionDetails?.banner_logo}
            name="banner_logo"
            label="Main Logo"
            extra="Please use image with size 274px width and 274px height"
          />
        </Col>

        {/* <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <InputBox.Text  name="customer_discovery_title" label="Customer Discovery Title" />
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <InputBox.Text  name="customer_discovery_url" label="Customer Discovery URL" />
        </Col> */}

        {/* <>{inputFields}</> */}




     
      </Row>
    </>
  );
};

export default BannerSection;
